import React, { useState } from "react";
import { ModalWrapper } from "./ModalWrapper";
import { POPUP_STYLES } from "../../constants/popupStyles";

interface TwoFactorVerifyModalProps {
    isOpen: boolean;
    onClose: () => void;
    onVerify: (token: string) => void;
    error?: string;
}

export const TwoFactorVerifyModal: React.FC<TwoFactorVerifyModalProps> = ({
    isOpen,
    onClose,
    onVerify,
    error,
}) => {
    const [token, setToken] = useState("");

    const handleVerify = () => {
        if (token.trim()) {
            onVerify(token);
            setToken("");
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" && token.trim()) {
            handleVerify();
        }
    };

    return (
        <ModalWrapper
            isOpen={isOpen}
            onClose={onClose}
            title="Two-Factor Authentication"
        >
            <div>
                <div className="mb-6">
                    <input
                        type="text"
                        placeholder="Enter 6-digit code"
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        onKeyPress={handleKeyPress}
                        maxLength={6}
                        autoFocus
                        className={POPUP_STYLES.input}
                    />
                    <p className="text-xs text-[#366A75] mt-2 text-center">
                        Enter the 6-digit code from your authenticator app
                    </p>
                    {error && (
                        <p className="text-red-600 text-sm font-semibold mt-3 text-center">
                            {error}
                        </p>
                    )}
                </div>

                <div className="flex gap-4 justify-center">
                    <button
                        onClick={onClose}
                        className={POPUP_STYLES.button}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleVerify}
                        disabled={!token.trim()}
                        className={POPUP_STYLES.button}
                    >
                        Verify
                    </button>
                </div>
            </div>
        </ModalWrapper>
    );
};
